import React, { useEffect, useState, useCallback, useRef } from "react";
import { Spinner } from "components/common";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import { OidcSessionActions } from "./OidcSessionStore";
import OidcGenericLoginLink from "./OidcGenericLoginLink";
import OktaLoginForm from "../okta/OktaLoginForm";
const OidcCallback = ({ configuration, nonce, onErrorChange, params, regenerateNonce }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const isRegenerated = useRef(false);
  const generateNonce = useCallback(() => {
    if (!isRegenerated.current) {
      regenerateNonce();
      isRegenerated.current = true;
    }
  }, [regenerateNonce]);
  useEffect(() => {
    const handleLoginFailure = () => {
      setLoginFailed(true);
      generateNonce();
    };
    if (loginFailed) {
      return () => {
      };
    }
    if (params.error_description) {
      onErrorChange(params.error_description);
      handleLoginFailure();
      return () => {
      };
    }
    if (nonce.state !== params.state) {
      onErrorChange(
        "A possible CSRF attempt has been detected, the state parameter does not match the request. Please contact an administrator."
      );
      handleLoginFailure();
      return () => {
      };
    }
    setIsLoading(true);
    const promise = OidcSessionActions.login(params.code);
    promise.catch((error) => {
      if (error.status === 401) {
        onErrorChange("Login failed. This might be a temporary problem. Please try again.");
      } else {
        onErrorChange("Unknown error, please retry or contact an administrator.");
      }
      handleLoginFailure();
      setIsLoading(false);
      return error;
    });
    return () => {
      var _a;
      if (promise) {
        (_a = promise.cancel) == null ? void 0 : _a.call(promise);
      }
    };
  }, [generateNonce, loginFailed, nonce.state, onErrorChange, params]);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement("p", { className: "loading-text" }, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading, please wait...", delay: 0 }));
  }
  return configuration.oauth_type === OKTA_TYPE_KEY ? /* @__PURE__ */ React.createElement(OktaLoginForm, { configuration, nonce }) : /* @__PURE__ */ React.createElement(OidcGenericLoginLink, { configuration, nonce });
};
export default OidcCallback;
